"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_helmet_1 = __importDefault(require("react-helmet"));
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
const ContentHeader_1 = __importDefault(require("@Components/ContentHeader"));
const SongwriterCatalogBuilderHeader_1 = __importDefault(require("@Scenes/SongwriterScene/SongwriterCatalogBuilderScene/SongwriterCatalogBuilderHeader"));
const contexts_1 = require("@App/contexts");
const WriterSearch_1 = __importDefault(require("@Components/WriterSearch"));
require("./index.scss");
const songwriter_writer_search_store_1 = require("@App/stores/search/songwriter-writer-search-store");
const SongwriterCatalogBuilderResults_1 = __importDefault(require("@Scenes/SongwriterScene/SongwriterCatalogBuilderScene/SongwriterCatalogBuilderResults"));
const react_router_dom_1 = require("react-router-dom");
const SongwriterCatalogBuilderScene = () => {
    const { songwriterWriterSearchStore, songwriterStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const location = (0, react_router_dom_1.useLocation)();
    (0, react_1.useEffect)(() => {
        var _a;
        // If it's a user's first time in the songwriter hub we automatically plug in their songwriter name
        // and search the catalog builder for them
        if ((_a = location.state) === null || _a === void 0 ? void 0 : _a.firstTimeVisit) {
            songwriterWriterSearchStore.setWriterNameForSearch(songwriterStore.songwriterSummary.name);
            songwriterWriterSearchStore.searchForParties().then();
        }
        return () => {
            songwriterWriterSearchStore.resetStore();
        };
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: 'Catalog Builder' }),
        react_1.default.createElement("div", { className: "songwriter-link-wrapper" },
            react_1.default.createElement(ContentHeader_1.default, { title: 'Catalog Builder', content: react_1.default.createElement(SongwriterCatalogBuilderHeader_1.default, null) }),
            react_1.default.createElement("div", { className: "songwriter-writer-search" },
                react_1.default.createElement(WriterSearch_1.default, { searchStore: songwriterWriterSearchStore, renderPartyResultsTable: (onTitleClick, setLoading) => (react_1.default.createElement(SongwriterCatalogBuilderResults_1.default, { setLoading: setLoading, onTitleClick: onTitleClick, songwriterWriterSearchStore: songwriterWriterSearchStore })), searchFilters: songwriter_writer_search_store_1.SongwriterSearchFilters, setSearchFilters: (filter) => songwriterWriterSearchStore.setCurrentSearchFilters(filter) })))));
};
exports.default = (0, mobx_react_1.observer)(SongwriterCatalogBuilderScene);
